import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

class TaxesAPIs {
  static async updateTaxes(branchId: number, payload: any) {
    const formData = new FormData()
    const body = FormsService.buildFormData(formData, payload)
    const config = { headers: FormsService.MULTIPART_HEADER }
    body.append('_method', 'put')
    return (await $http.post(`/ordering/taxes/${branchId}`, body, config)).data
  }

  static async getTaxes(branchId: number) {
    return (await $http.get(`/ordering/taxes/${branchId}`)).data
  }

  static async getTaxGroups(branchId: number) {
    return (await $http.get(`/ordering/taxes-groups/${branchId}?paginate=0`)).data
  }

  static async addGroupTax(payload: any) {
    return (await $http.post('/ordering/taxes/add-group', payload)).data
  }

  static async updateGroupTax(id: number, payload: any) {
    return (await $http.post(`/ordering/taxes/update-group/${id}`, payload)).data
  }

  static async deleteGroupTax(id: number) {
    return (await $http.delete(`/ordering/taxes/delete-group/${id}`)).data
  }
}

export default TaxesAPIs
